export const LANGUAGES = ["en", "bg", "mk"]